import { createClient } from "../../prismicio";
import { useState } from "react";
import Head from "next/head";
import { StudentAgreementForm } from "@/components";

const StudentAgreementFormPage = () => {
	const [signStep, setSignStep] = useState(false);

	return (
		<>
			<Head>
				<title>Student Training Agreement | Tech Safety Lines</title>
			</Head>
			<main className='studentAgreementMain'>
				<section data-contain='true'>
					<div>
						{!signStep && (
							<StudentAgreementForm
								setSignStep={setSignStep}
								manualForm={true}
							/>
						)}
						{signStep && (
							<>
								<div className='studentAgreementAlertBanner'>
									Please use the email you provided on the previous form to sign
									the agreement.
								</div>
								<iframe
									title='TSL End User Student Agreement Global'
									src='https://www.jotform.com/sign/243423704853052/invite/01jekbba1d7cc1789bacf30893?signEmbed=1'
									style={{
										height: "70vh",
										width: "100%",
										border: "0",
									}}></iframe>
							</>
						)}
					</div>
				</section>
			</main>
		</>
	);
};

export default StudentAgreementFormPage;

export async function getStaticProps({ previewData }) {
	const client = createClient({ previewData });
	const nav = await client.getSingle("nav");
	const footer = await client.getSingle("footer");

	return {
		props: {
			nav,
			footer,
		},
	};
}
